import { useTranslation } from '@nextgen-web-framework/all';
import styles from './OtpCheckingLabel.module.scss';

const OtpCheckingLabel = () => {
  const t = useTranslation();
  return (
    <div data-testid="otp-checking-test-id" className={styles['identity-otp-checking-label']}>
      <div className={styles['loading-spinner']}></div>
      <div className={styles['checking-code-label']}>{t('identity.VerifyOtp.checkingCodeLabel')}</div>
    </div>
  );
};

export default OtpCheckingLabel;
